import { CSSProperties } from "react";
import { Size, SX, Theme } from "./types";

export const getSizePx = (sizeName: Size | undefined): number => {
  switch (sizeName) {
    case "m":
      return 40;
    case "s":
      return 36;
    case "xs":
      return 32;
    default:
      return 40;
  }
};

const iconSizes = {
  xs: 10,
  s: 13,
  m: 16,
};

export const getIconSize = (iconSize: Size): number => {
  if (iconSize === "xs") return iconSizes.xs;
  if (iconSize === "s") return iconSizes.s;
  if (iconSize === "m") return iconSizes.m;
  return iconSizes.m;
};

export const getTypographyVariantWithBold = (
  sizeName: Size | undefined,
  bold: boolean,
): string => {
  if (!bold) {
    return getTypographyVariant(sizeName);
  }
  switch (sizeName) {
    case "m":
      return "body-bold";
    case "s":
      return "body-small-bold";
    case "xs":
      return "body-x-small-bold";
    default:
      return "body-bold";
  }
};

export const getTypographyVariant = (sizeName: Size | undefined): string => {
  switch (sizeName) {
    case "m":
      return "body";
    case "s":
      return "body-small";
    case "xs":
      return "body-x-small";
    default:
      return "body";
  }
};

export const buildCSSObjectFromSX = (
  sx: SX,
  themeParam: Theme,
): CSSProperties => {
  const { color: colorName, ...rest } = sx;
  const color = colorName ? themeParam.COLORS[colorName] : null;

  return {
    ...rest,
    ...(color && {
      color,
    }),
  };
};
